import { Link } from 'react-router-dom';
import Seo from '@/components/Seo';
import { GUIDES } from '@/lib/guides';
import { ArrowRight, BookOpen } from 'lucide-react';

export default function GuidesIndex() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    itemListElement: GUIDES.map((g, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: g.h1,
      url: `https://tradesmateuk.co.uk/guides/${g.slug}`,
    })),
  };

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-testid="guides-index">
      <Seo
        title="Trade & Cost Guides"
        description="Free UK trade guides answering the questions tradesmen and homeowners actually Google — resin driveway cost, block paving prices, how many bricks per m² and more."
        path="/guides"
        kicker="// Guides"
        jsonLd={jsonLd}
      />
      <header className="mb-10">
        <p className="text-xs uppercase tracking-widest text-brand font-semibold">{GUIDES.length} free guides</p>
        <h1 className="font-display font-semibold text-4xl sm:text-5xl uppercase tracking-tight mt-1 flex items-center gap-3">
          <BookOpen className="text-brand" size={36} /> Trade &amp; Cost Guides
        </h1>
        <p className="text-slate-600 mt-3 max-w-2xl">
          Straight answers to the costing and quantity questions UK tradesmen and their customers search for most — each one links to a free calculator to do the maths for you.
        </p>
      </header>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {GUIDES.map((g) => (
          <Link
            key={g.slug}
            to={`/guides/${g.slug}`}
            data-testid={`guide-card-${g.slug}`}
            className="tm-card p-5 flex flex-col gap-2 hover:shadow-lg transition-shadow"
          >
            <span className="text-[11px] uppercase tracking-widest text-brand font-semibold">{g.kicker}</span>
            <h2 className="font-display font-bold text-lg uppercase tracking-tight leading-tight">{g.h1}</h2>
            <p className="text-slate-600 text-sm flex-1">{g.metaDescription}</p>
            <span className="text-xs uppercase tracking-widest text-slate-900 inline-flex items-center gap-1 mt-1 font-semibold">
              Read guide <ArrowRight size={14} className="text-brand" />
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
}
